<template>
  <a
    class="text-primary cookie-preferences-link"
    href="#"
    @click.prevent="openPreferences"
    v-text="$t('legal.links.privacyPreferences')"
  />
</template>

<script>
export default {
  methods: {
    openPreferences() {
      if (window._iub) {
        window._iub.cs.api.openPreferences()
      }
    },
  },
}
</script>
<style>
/* clone of .iubenda-embed */
.v-application .cookie-preferences-link {
  display: inline-block;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3E%3Cpath fill='%231CC691' fill-rule='evenodd' d='M16 7a4 4 0 0 1 2.627 7.016L19.5 25h-7l.873-10.984A4 4 0 0 1 16 7z'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-size: 21px 21px !important;
  background-position: top left !important;
  padding: 1px 8px !important;
  padding-left: 20px !important;
  font-size: 12px;
  text-decoration: none;
  font-weight: 600;
  border: 1px solid #d9d5d5;
  border-radius: 2px;
}
.cookie-preferences-link:hover {
  -webkit-box-shadow:
    inset 0 0 0 1px rgba(0, 0, 0, 0.15),
    0 1px 1px -1px rgba(0, 0, 0, 0.15) !important;
  box-shadow:
    inset 0 0 0 1px rgba(0, 0, 0, 0.15),
    0 1px 1px -1px rgba(0, 0, 0, 0.15) !important;
  background-color: #fffcfc !important;
}
</style>
